/* oxlint-disable typescript/no-explicit-any */
import { IModelResponse } from '@cian/http-api';

export interface IRatingItem {
  agencyItem: TRating;
  expandedItem: number | null;
  onExpandedItem?: (id: number) => void;
}

export interface IMedal {
  pos: number;
  label: string;
}

export type TRatingResponse = IRatingResponse200 | IRatingResponse400;

export interface IRatingResponse200 extends IModelResponse<IRatingResponse> {
  statusCode: 200;
}

export interface IRatingResponse400 extends IModelResponse<IRatingResponseError> {
  statusCode: 400;
}

export interface IRatingResponse {
  data: TRating[];
  status: EStatus;
}

export interface IRatingResponseError {
  errors: any[];
  message: string;
}

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export interface IAgency {
  nameGroup: string;
  cianuserid: number;
  mainId: number;
  userid: number;
  regionName: string;
  dateRating: string;
  posShows: number;
  changePosition: number;
  url: string;
  urlLogo: string;
  shows: number;
  posShowsSale: number;
  posShowsRent: number;
  posCntPremium: number;
  posCntTop: number;
  posRealAmountAuction: number;
  posArea: number;
  description: string | string[];
  experience: string;
}

export interface IAgencyAccount {
  regionName: string;
  userid: number;
  dateRating: string;
  prevPosShows: number;
  changePosition: number;
  posShows: number;
  shows: number;
  cianuserid: number;
  agencyname: string;
  url: string;
  linkLogo: string;
  mainId: number;
  managerLogin: string;
  groupname: string;
  cianId: number;
  translit: string;
}

export enum ERatingStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export type TRating = {
  agency: IAgency;
  agencyAccounts: IAgencyAccount[];
} | null;

export interface IRatingState {
  rating: TRating[] | null;
  status: ERatingStatus;
}
